import { IAddressInfoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

/**
 * Фильтрует массив адресов, оставляя только округ и район
 */
export function getGeoAddress(address: IAddressInfoSchema[]): IAddressInfoSchema[] {
  return address.filter(({ type }) => type === 'okrug' || type === 'raion');
}
